<template>
  <v-card height="fit-content" flat>
    <v-form ref="formStep1" lazy-validation>
      <v-row style="backdrop-filter: blur(10px)" class="elevation-6 mt-4">
        <v-col cols="12" md="5" sm="12" xl="5" lg="5" xs="12">
          <v-card-title class="primary--text ml-n3 mt-n5"
            >Your Personal Details</v-card-title
          >
          <v-row class="mb-n9">
            <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
              <v-text-field
                v-model="getbasicinfo1.first_name"
                label="First Name"
                color="primary"
                required
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-n9">
            <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
              <v-text-field
                v-model="getbasicinfo1.middle_name"
                label="Middle Name"
                color="primary"
                readonly
                required
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-n9">
            <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
              <v-text-field
                label="Last Name"
                v-model="getbasicinfo1.last_name"
                color="primary"
                required
                outlined
                readonly
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-n9">
            <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12">
              <v-text-field
                label="Designation"
                color="primary"
                readonly
                v-model="getbasicinfo1.designation"
                required
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="12"
              xl="6"
              lg="6"
              xs="12"
              :class="isMobile ? 'mt-n6' : ''"
            >
              <v-text-field
                label="Contact Number"
                v-model="getbasicinfo1.contact_num"
                maxlength="11"
                prefix="+60"
                color="primary"
                readonly
                required
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mb-n9">
            <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
              <v-text-field
                outlined
                dense
                readonly
                append-icon="mdi-person"
                label="E-mail"
                v-model="$store.getters.get_useremail"
                value
              ></v-text-field
            ></v-col>
          </v-row>
        </v-col>
        <v-divider light vertical class="mx-n1"></v-divider>
        <v-col cols="12" md="7" sm="7">
          <v-row>
            <v-card-title class="primary--text mt-n2"
              >Your Company Details</v-card-title
            >
          </v-row>
          <v-row class="mb-n12 mt-n3">
            <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
              <v-textarea
                label="Company Name"
                v-model="getbasicinfo1.comp_name"
                maxlength="12"
                color="primary"
                required
                dense
                readonly
                outlined
                auto-grow
                rows="1"
                row-height="35"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mb-n9 mt-6">
            <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12">
              <v-text-field
                v-model="getbasicinfo1.ent_type"
                readonly
                label="Type of Entity"
                required
                outlined
                dense="dense"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              sm="12"
              xl="6"
              lg="6"
              xs="12"
              :class="isMobile ? 'mt-n6' : ''"
            >
              <v-text-field
                v-model="getbasicinfo1.registration_num"
                label="Company Registration Number"
                color="primary"
                maxlength="15"
                required
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="mb-n9">
            <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
              <v-text-field
                label="Nature of business"
                v-model="getbasicinfo1.nat_of_busn"
                readonly
                required
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="elevation-6 mt-4">
        <!-- <v-divider light vertical class="mx-n1"></v-divider> -->
        <v-col cols="12">
          <v-card-title class="primary--text ml-n3 mt-n5"
            >Registered Address</v-card-title
          >
        </v-col>

        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
          <v-textarea
            v-model="getaddresslist.addressline1"
            label="Address Line 1"
            outlined
            readonly
            auto-grow
            rows="2"
            row-height="15"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
          <v-textarea
            label="Address Line 2"
            v-model="getaddresslist.addressline2"
            outlined
            auto-grow
            readonly
            rows="2"
            row-height="15"
          ></v-textarea>
        </v-col>
        <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
          <v-text-field
            label="City"
            v-model="getaddresslist.city"
            color="primary"
            readonly
            required
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
          <v-text-field
            label="Selected State"
            color="primary"
            required
            readonly
            v-model="getaddresslist.state"
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
          <v-text-field
            label="Country"
            v-model="getaddresslist.country"
            readonly
            color="primary"
            required
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
          <v-text-field
            label="Enter Postal Code"
            maxlength="5"
            readonly
            :rules="rules.title"
            v-model="getaddresslist.zip_code"
            color="primary"
            required
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12">
          <v-card-title class="primary--text ml-n3 mt-n10"
            >Business Address</v-card-title
          ></v-col
        >
        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12">
          <v-checkbox
            class="mt-n6"
            dense
            readonly
            v-model="checkbox"
            label="Same As Registered Address "
          ></v-checkbox>
        </v-col>
        <v-row v-if="checkbox == false" class="pa-3">
          <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
            <v-textarea
              label="Address Line 1"
              v-model="getaddresslist1.addressline1"
              outlined
              auto-grow
              readonly
              rows="2"
              row-height="15"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
            <v-textarea
              v-model="getaddresslist1.addressline2"
              label="Address Line 2."
              outlined
              readonly
              auto-grow
              rows="1"
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
            <v-text-field
              label="City"
              v-model="getaddresslist1.city"
              color="primary"
              required
              readonly
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
            <v-text-field
              label="Selected State"
              color="primary"
              readonly
              item-text="state_name"
              v-model="getaddresslist1.state"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
            <v-text-field
              readonly
              label="Country"
              color="primary"
              :rules="rules.title"
              v-model="getaddresslist1.country"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" sm="12" xl="3" lg="3" xs="12" class="mt-n5">
            <v-text-field
              label="Enter Postal Code"
              v-model="getaddresslist1.zip_code"
              maxlength="5"
              readonly
              :rules="rules.title"
              color="primary"
              required
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
      </v-row>

      <v-row class="elevation-6 mt-4">
        <!-- <v-card> -->
        <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12">
          <v-card-title class="primary--text ml-n3 mt-n5"
            >First Card Information</v-card-title
          >
        </v-col>
        <v-col cols="12" md="4" sm="12" xl="4" lg="4" xs="12" class="mt-n5">
          <v-text-field
            label="First Name"
            v-model="cardinfo.fname"
            color="primary"
            required
            outlined
            readonly
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="12" xl="4" lg="4" xs="12" class="mt-n5">
          <v-text-field
            v-model="cardinfo.mname"
            label="Middle Name"
            color="primary"
            required
            readonly
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" sm="12" xl="4" lg="4" xs="12" class="mt-n5">
          <v-text-field
            v-model="cardinfo.lname"
            label="Last Name"
            color="primary"
            required
            readonly
            outlined
            dense
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
          <v-text-field
            outlined
            readonly
            dense
            v-model="cardinfo.email_id"
            append-icon="mdi-person"
            label="E-mail"
            value
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
          <v-text-field
            dense
            v-model="cardinfo.mobileno"
            label="Mobile Number"
            maxlength="12"
            readonly
            @keypress="isNumber(event)"
            outlined
            prefix="+60"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
          <v-text-field
            dense
            readonly
            v-model="cardinfo.designation"
            label="Designation"
            maxlength="25"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" sm="12" xl="6" lg="6" xs="12" class="mt-n5">
          <v-text-field
            dense
            label="Passport/NRIC No."
            v-model="cardinfo.idnum"
            maxlength="18"
            readonly
            outlined
          ></v-text-field>
        </v-col>
        <!-- </v-card> -->
      </v-row>
      <v-row v-if="bankinfocheck" class="elevation-6 mt-4">
        <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12" class="mt-n5">
          <v-card-title class="primary--text ml-n3 mt-n0"
            >Bank Information</v-card-title
          >
        </v-col>
        <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12" class="mt-n5">
          <v-data-table
            :headers="headersBank"
            :items="getbankList"
            class="elevation-0"
            item-key="bank_account_num"
          >
            <!-- v-model="selected" -->
            <template v-slot:[`item.primary_acc`]="{ item }">
              <v-simple-checkbox
                v-model="item.primary_acc"
                disabled
              ></v-simple-checkbox>
            </template>
            <template v-slot:[`item.bank_name`]="{ item }" v-if="isMobile">
              <v-tooltip bottom color="primary" class="pa-3">
                <template v-slot:activator="{ on }">
                  <h4 class="caption" v-on="on">
                    {{
                      item.bank_name.length >= 15
                        ? item.bank_name.substr(0, 15) + "..."
                        : item.bank_name
                    }}
                  </h4>
                </template>
                <span class="caption">{{ item.bank_name }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="elevation-6 mt-4">
        <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12" class="mt-n2">
          <v-card-title class="primary--text ml-n3 mt-n2"
            >Uploaded Documents</v-card-title
          >
        </v-col>
        <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12" class="mt-n2">
          <v-data-table
            :headers="headersUploader"
            :items="filelistOrg"
            class="elevation-0"
          >
            <template v-slot:[`item.docUrl`]="{ item }">
              <v-avatar tile size="36" class="mt-1">
                <img
                  v-if="
                    item.docExtn == 'jpeg' ||
                    item.docExtn == 'JPEG' ||
                    item.docExtn == 'jpg' ||
                    item.docExtn == 'JPG' ||
                    item.docExtn == 'png' ||
                    item.docExtn == 'PNG' ||
                    item.docExtn == 'webp' ||
                    item.docExtn == 'WEBP'
                  "
                  :src="item.docUrl"
                  alt="error"
                  @click="openImageInNewTab(item.docUrl)"
                />

                <v-icon
                  @click="openImageInNewTab(item.docUrl)"
                  v-else-if="item.docExtn == 'pdf'"
                  left
                  color="red"
                  >mdi-file-pdf</v-icon
                >
                <v-icon
                  @click="openImageInNewTab(item.docUrl)"
                  v-else-if="item.docExtn == 'xls' || item.docExtn == 'xlsx'"
                  left
                  color="green"
                  >mdi-file-excel</v-icon
                >
                <v-icon
                  @click="openImageInNewTab(item.docUrl)"
                  v-else-if="item.docExtn == 'doc' || item.docExtn == 'docx'"
                  left
                  color="blue"
                  >mdi-file-word</v-icon
                >
                <v-icon
                  @click="openImageInNewTab(item.docUrl)"
                  v-else
                  left
                  color="blue"
                  >mdi-file-document</v-icon
                >
              </v-avatar>
              <v-tooltip bottom color="primary">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <span class="caption justify-center">
                      {{
                        item.fileName.length >= 15
                          ? item.fileName.substr(0, 15) + "..."
                          : item.fileName
                      }}</span
                    >
                  </div>
                </template>
                <span class="primary">{{ item.fileName }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.doc_name`]="{ item }" v-if="isMobile">
              <v-tooltip bottom color="primary" class="pa-3">
                <template v-slot:activator="{ on }">
                  <h4 class="caption" v-on="on">
                    {{
                      item.doc_name.length >= 20
                        ? item.doc_name.substr(0, 20) + "..."
                        : item.doc_name
                    }}
                  </h4>
                </template>
                <span class="caption">{{ item.doc_name }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small color="red" @click="confirmdeleteItem(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table></v-col
        >
      </v-row>
    </v-form>

    <v-col cols="12" md="12" sm="12" xl="12" lg="12" xs="12" class="mt-n2">
      <v-checkbox v-model="checkboxTrns">
        <template v-slot:label>
          <div class="caption">
            By clicking submit or otherwise continuing to use this service, you
            agree you have read, understand and accept Glyd's
            <a
              target="_blank"
              href="https://glyd.com.my/term-and-condition.html"
              @click.stop
            >
              <span class="caption red--text">Terms of Service</span>
            </a>
            and
            <a
              target="_blank"
              href="https://glyd.com.my/privacy-policy.html"
              @click.stop
            >
              <span class="caption red--text">Privacy Policy</span>
            </a>
          </div>
        </template>
      </v-checkbox>
    </v-col>

    <v-col
      cols="12"
      md="12"
      sm="12"
      xl="12"
      lg="12"
      xs="12"
      class="text-center"
    >
      <v-btn class="mr-2 mt-n2" @click="basicmethod(2)" text>back</v-btn>
      <v-btn class="mr-5 mt-n2" color="primary" @click="basicmethod(1)"
        >Submit</v-btn
      >
    </v-col>

    <v-card-actions></v-card-actions>
  </v-card>
</template>
<script>
import { apiCall } from "@/Views/APICALL/APIcall.js";
  export default {
  data: () => ({
    getbasicinfo1: "",
    getaddresslist: "",
    getaddresslist1: "",
    cCode: "+60",
    cardinfo: "",
    fileList: [],
    filelistOrg: [],
    checkbox: false,
    checkboxTrns: false,
    rules: {
      title: [(v) => !!v || "Required"],
    },

    headersUploader: [
      {
        text: "Documents",
        align: "start",
        sortable: false,
        value: "doc_name",
      },
      {
        text: "Files",
        align: "start",
        sortable: false,
        value: "docUrl",
      },
    ],
    bankinfocheck: false,
    headersBank: [
      {
        text: "Acc Type",
        align: "start",
        sortable: false,
        value: "account_type",
      },
      {
        text: "Acc Name",
        align: "start",
        sortable: false,
        value: "account_name",
      },

      {
        text: "Bank Name",
        align: "start",
        sortable: false,
        value: "bank_name",
      },
      {
        text: "Acc No",
        align: "start",
        sortable: false,
        value: "bank_account_num",
      },

      {
        text: "Primary Acc",
        align: "start",
        sortable: false,
        value: "primary_acc",
      },
    ],
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  created() {
    // alert(20);
    this.getbasicinfo();
    this.getaddressinfo();
    this.getInfoCardDetails();
    this.getbankinfo();
    this.getUploadedDocuments();
  },
  methods: {
    basicmethod(datta) {
      if ((datta == 1 && this.checkboxTrns == true) || datta == 2) {
        this.$emit("backChild", { data: datta });
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Please Check Terms of Service and Privacy Policy",
          color: "red",
        });
      }
    },
    // back() {
    //   this.$emit("backChild1");
    // },
    async getbasicinfo() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BASICGET",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      this.getbasicinfo1 = responseData.data.data;
      // console.log("bafsicdata", this.getbasicinfo1);
    },
    async getbankinfo() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "BANKGET",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      //   console.log("fg", responseData);
      this.getbankList =
        responseData.data.data == "" || responseData.data.data == null
          ? []
          : responseData.data.data;

      // var self = this;
      // this.selected = [];
      this.getbankList.forEach(function (ele) {
        if (ele.primary_acc == 1) {
          ele.primary_acc = true;
          // self.selected.push(ele);
        } else {
          ele.primary_acc = false;
        }
      });
      // bankinfocheck
      if (this.getbankList != null || this.getbankList != "") {
        this.bankinfocheck = true;
      }
      // console.log("this.getbankList", this.getbankList);
    },
    getExtension(filename) {
      var i = filename.lastIndexOf(".");
      return i < 0 ? "" : filename.substr(i).replace(".", "").toLowerCase();
    },
    openImageInNewTab(url) {
      window.open(url, "_blank");
    },
    async getUploadedDocuments() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETDOC",
          id: this.$store.getters.get_corpid,

          type: 1,
        },
      };
      var responseData = await apiCall(inputData);
      this.checkdata = responseData.data.data;
      for (let i = 0; i < this.checkdata.length; i++) {
        this.docid = this.checkdata[i].doc_id;
        //  console.log("docid",this.docid);
      }

      this.fileList = [];
      this.filelistOrg = [];
      if (this.checkdata != null) {
        var self = this;
        if (
          this.$store.getters.getApiCredentials.baseUrl.includes("dev") == true
        ) {
          this.checkdata.forEach(function (ele) {
            var filesplit = ele.doc_url.split("/").pop();
            self.fileList.push({
              doc_name: ele.doc_name,
              docUrl: ele.doc_url,
              fileName: filesplit,
              docExtn: self.getExtension(filesplit),
              doc_id: ele.doc_id,
            });
          });
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("staging") ==
          true
        ) {
          this.checkdata.forEach(function (ele) {
            var filesplit = ele.doc_url.split("/").pop();
            self.fileList.push({
              doc_name: ele.doc_name,
              docUrl: ele.doc_url,
              fileName: filesplit,
              docExtn: self.getExtension(filesplit),
              doc_id: ele.doc_id,
            });
          });
        } else if (
          this.$store.getters.getApiCredentials.baseUrl.includes("corporate") ==
          true
        ) {
          this.checkdata.forEach(function (ele) {
            var filesplit = ele.doc_url.split("/").pop();
            self.fileList.push({
              doc_name: ele.doc_name,
              docUrl: ele.doc_url,
              fileName: filesplit,
              docExtn: self.getExtension(filesplit),
              doc_id: ele.doc_id,
            });
          });
        }
      }

      self.filelistOrg = [...self.fileList];
      // console.log("filelistOrg", self.filelistOrg);
      //  console.log("GETDOC1responseDataresponseData", self.fileList);
    },
    async getaddressinfo() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "ADDRESSGET",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);

      var datareg = responseData.data.data.regaddress;
      var databus = responseData.data.data.busaddress;
      if (datareg != null) {
        this.getaddresslist = datareg;

        // var add2 = datareg.address.split("##")[1];
        // this.getaddresslist.address = datareg.address.split("##")[0];
        // this.getaddresslist.addressline2 = add2;
      }
      if (databus != null) {
        this.getaddresslist1 = databus;
        // var addbus2 = databus.address.split("##")[1];
        // this.getaddresslist1.address = databus.address.split("##")[0];
        // this.getaddresslist1.addressline2 = addbus2;
      }
      if (
        this.getaddresslist.addressline1 == this.getaddresslist1.addressline1 &&
        this.getaddresslist.addressline2 == this.getaddresslist1.addressline2
      ) {
        this.checkbox = true;
      } else {
        this.checkbox = false;
      }

      this.e1 = 2;
      // this.$refs.Viewonboardpreview.addressdata = this.getaddresslist;
      // this.$refs.Viewonboardpreview.getaddresslist1 = this.getaddresslist1;
      // console.log("addressdatareg", this.getaddresslist);
      // console.log("addressdata", this.getaddresslist1);
    },
    async getInfoCardDetails() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GFSTCARD",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      //  console.log("thigetInfoCardDetails", responseData);
      this.cardinfo = responseData.data.data;

      if (responseData.data.status == "00") {
        this.cardIFullname = responseData.data.data.fname;
        this.cardIMiddlename = responseData.data.data.mname;
        this.cardILastname = responseData.data.data.lname;
        this.cardIEmail = responseData.data.data.email_id;
        this.cardMobilNo = responseData.data.data.mobileno;
        this.carddesignatn = responseData.data.data.designation;
        this.cardNRIC = responseData.data.data.idnum;
      }
    },
  },
};
</script>
